import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  Input,
  Label,
  Popover,
  PopoverBody,
  UncontrolledTooltip,
} from "reactstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import UserDetailView from "./UserDetailView";
import { REGEX } from "constants/CommonConstants";
import VisitorVerifyModal from "./VisitorVerifyModal";
import NotFoundPage from "./NotFoundPage";
import MainLayout from "./MainLayout";
import { NotificationContext } from "components/CommonComponents/NotificationProvider";
import { getJointerDetails } from "action/auth";
import { visitorLogout } from "action/auth";

const SkillVerification = () => {
  const { notify } = useContext(NotificationContext);
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  const [showEntryModal, setShowEntryModal] = useState(false);
  const [uniqueID, setUniqueID] = useState(null);
  const [searchForm, setSearchForm] = useState({
    jointerID: "",
    name: "",
    certificateNo: "",
  });
  const [alternatives, setAlternatives] = useState({
    showUserDetail: false,
    isSearching: false,
    hasSearched: false,
    isLoading: false,
  });

  const [searchData, setSearchData] = useState({
    searchError: "",
    searchFieldErrors: { jointerID: "", name: "", certificateNo: "" },
    searchResults: [],
    selectedUser: {},
    setProps: false,
    setBack: false,
    isPDF: false,
  });

  const [invalidParam, setInvalidParam] = useState(false);
  const [searchMode, setSearchMode] = useState("CERT_ID"); // JOINTER_ID
  const [certificatePopover, setCertificatePopover] = useState();

  // This useEffect executes and check if cookie is avaliable, if yes then hide visitor verfiy popup other-wise show that popup
  useEffect(() => {
    const getCookie = (name) => {
      const cookieMap = Object.fromEntries(
        document.cookie.split("; ").map((c) => c?.trim()?.split(/=(.+)/)),
      );
      return cookieMap[name] ? decodeURIComponent(cookieMap[name]) : null;
    };

    const init = async () => {
      const visitorUUID = getCookie("visitor_search_id");
      if (!visitorUUID) {
        setShowEntryModal(true);
        return;
      }
      const isDeleted = await verifyVisitor(visitorUUID);
      if (isDeleted) {
        setShowEntryModal(true);
        return;
      }
      setShowEntryModal(!visitorUUID);
      setUniqueID(visitorUUID);

      if (
        !searchForm.jointerID &&
        !searchForm.certificateNo &&
        id &&
        visitorUUID
      ) {
        setAlternatives((prev) => ({
          ...prev,
          showUserDetail: true,
          isSearching: false,
        }));
        triggerSearch({
          jointerUUID: id,
          uniqueID: visitorUUID,
          searchType: "ENCODED_UUID",
        });
      }

      if (searchData.setBack && searchData.setProps && visitorUUID) {
        let params = {};
        if (searchMode === "JOINTER_ID") {
          params = {
            jointerID: searchForm.jointerID,
            name: searchForm.name,
            uniqueID: visitorUUID,
            searchType: "JOINTER_ID",
          };
        } else if (searchMode === "CERT_ID") {
          params = {
            certificateNo: searchForm.certificateNo,
            name: searchForm.name,
            uniqueID: visitorUUID,
            searchType: "CERTIFICATE_NO",
            shouldInsertSearch: "YES",
          };
        }
        triggerSearch(params);
        setSearchData((prev) => ({ ...prev, setBack: false }));
      }
    }
    init()
  }, [id]);

  const verifyVisitor = async (visitorUUID) => {
    const res = await visitorLogout({ searchType: "verify", uniqueID: visitorUUID });
    return res?.data?.isDeleted || false;
  }

  const handleCloseVisitorModal = (uniqueID) => {
    setShowEntryModal(false);
    if (id && uniqueID) {
      setAlternatives((prev) => ({
        ...prev,
        showUserDetail: true,
        isSearching: false,
      }));
      triggerSearch({
        jointerUUID: id,
        uniqueID,
        searchType: 'ENCODED_UUID'
      });
    }
  };

  const handleTabChange = (tab) => {
    setSearchMode(tab);
    setSearchData({
      searchError: "",
      searchFieldErrors: { jointerID: "", name: "", certificateNo: "" },
      searchResults: [],
      selectedUser: {},
      setProps: false,
      setBack: false,
      isPDF: false,
    });
    setSearchForm({
      jointerID: "",
      name: "",
      certificateNo: "",
    });
  };

  const validateField = ({ name, value }) => {
    let error = "";
    // searchMode === "JOINTER_ID" &&
    switch (name) {
      case "name":
        if (!value) {
          return (error = "Please enter jointer name");
        } else if (value.length < 2) {
          return (error = "Name must be at least 2 characters long.");
        } else if (value.length > 20) {
          return (error = "Name cannot exceed 20 characters.");
        } else if (!REGEX.NAME_REGEX.test(value)) {
          return (error =
            "Name should start with at least 2 letters and contain only letters and spaces.");
        }

      case "jointerID":
        if (!value) {
          return (error = "Please enter jointer ID");
        }

      case "certificateNo":
        if (!value) {
          return (error = "Please enter certificate number");
        }
      default:
        return "";
    }
    // if (name === "name") {
    //   if (!value) {
    //     error = "Please enter jointer name";
    //   } else if (value.length < 2) {
    //     error = "Name must be at least 2 characters long.";
    //   } else if (value.length > 20) {
    //     error = "Name cannot exceed 20 characters.";
    //   } else if (!REGEX.NAME_REGEX.test(value)) {
    //     error =
    //       "Name should start with at least 2 letters and contain only letters and spaces.";
    //   }
    // }

    // if (name === "jointerID") {
    //   if (!value) {
    //     error = "Please enter jointer ID";
    //   }
    // }

    // if (name === "certificateNo") {
    //   if (!value) {
    //     error = "Please enter certificate number";
    //   }
    // }

    // return error;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Update form value
    // setSearchForm((prev) => ({ ...prev, [name]: value }));
    setSearchForm((prev) => ({
      ...prev,
      [name]: value,
      // ...(name === "jointerID" && value ? { certificateNo: "" } : {}),
      // ...(name === "certificateNo" && value ? { jointerID: "" } : {}),
    }));
    setSearchData((prev) => ({
      ...prev,
      searchFieldErrors: {
        ...prev.searchFieldErrors,
        [name]: "",
      },
      setProps: false,
    }));

    // Validate the field and update error
    // const error = validateField({ name, value });
    // setSearchData((prev) => ({
    //   ...prev,
    //   searchFieldErrors: { ...prev.searchFieldErrors, [name]: error },
    // }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    // Trim the value
    const trimmedValue = value?.trim();

    // Update the form state
    setSearchForm((prev) => ({
      ...prev,
      [name]: trimmedValue,
    }));

    // Re-validate the trimmed value
    const error = validateField({ name, value: trimmedValue });
    setSearchData((prev) => ({
      ...prev,
      searchFieldErrors: { ...prev.searchFieldErrors, [name]: error },
    }));
  };

  const handleKeyDown = (e, isID = false) => {
    if (!isID && e.key >= "0" && e.key <= "9") {
      e.preventDefault();
    }
    // if (e.key === " ") {
    //   e.preventDefault();
    // }
    if (e.key === "Enter") {
      handleSearch(e);
    }
  };

  const triggerSearch = async (params) => {
    setAlternatives((prev) => ({
      ...prev,
      isSearching: true,
      hasSearched: true,
      isLoading: true,
    }));

    // const
    try {
      const res = await getJointerDetails(params);
      const contentType = res?.headers?.["content-type"];
      if (contentType?.includes("application/pdf")) {
        if (res?.status === 200) {
          const fileURL = URL.createObjectURL(res?.data);

          setSearchData((prev) => ({
            ...prev,
            // setProps: false,
            selectedUser: fileURL,
            searchResults: [],
            isPDF: true,
          }));

          setAlternatives((prev) => ({
            ...prev,
            showUserDetail: true,
            isSearching: false,
            isLoading: false,
          }));
        } else {
          const message = Array.isArray(res?.message)
            ? res?.message[0]?.Msg
            : res?.message || "Please check entered records.";
          // notify("danger", "Jointer records not found.");
          setSearchData((prev) => ({
            ...prev,
            searchError: message,
          }));
          setSearchData((prev) => ({
            ...prev,
            searchResults: [],
            selectedUser: {},
          }));
          setAlternatives((prev) => ({
            ...prev,
            showUserDetail: false,
            isSearching: false,
            isLoading: false,
          }));
          const basePath = location.pathname.split("/").slice(0, -1).join("/");
          navigate(basePath, { replace: true });
        }
      } else if (contentType?.includes("application/json")) {
        // Convert blob to JSON
        const text = await res?.data.text();
        const json = JSON.parse(text);
        const userData = json?.data?.jointerDetailResponse;
        const dataLength = userData?.length;

        if (json?.code === 200 && userData) {
          // notify("success", "Jointner details retrieved successfully.");
          setSearchData((prev) => ({
            ...prev,
            // setProps: false,
            searchResults: dataLength === 1 ? [] : userData,
            selectedUser: dataLength === 1 ? userData[0] : {},
            isPDF: false,
          }));

          if (dataLength === 1) {
            setAlternatives((prev) => ({
              ...prev,
              showUserDetail: true,
              isSearching: false,
              isLoading: false,
            }));
            navigate(`/skills-verification/${userData[0]?.jointerEncodedID}`, {
              replace: true,
            });
          } else {
            setAlternatives({
              showUserDetail: false,
              isSearching: false,
              hasSearched: true,
              isLoading: false,
            });
          }
        } else {
          const message = Array.isArray(res?.message)
            ? res?.message[0]?.Msg
            : res?.message || "Please check entered records.";
          // notify("danger", "Jointer records not found.");
          setSearchData((prev) => ({
            ...prev,
            searchError: message,
          }));
          setSearchData((prev) => ({
            ...prev,
            searchResults: [],
            selectedUser: {},
          }));
          setAlternatives((prev) => ({
            ...prev,
            showUserDetail: false,
            isSearching: false,
            isLoading: false,
          }));
          const basePath = location.pathname.split("/").slice(0, -1).join("/");
          navigate(basePath, { replace: true });
        }
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Something went wrong. Please try again.";
        setSearchData((prev) => ({
          ...prev,
          searchError: message,
        }));
        setSearchData((prev) => ({
          ...prev,
          searchResults: [],
          selectedUser: {},
        }));
        setAlternatives((prev) => ({
          ...prev,
          showUserDetail: false,
          isSearching: false,
          isLoading: false,
        }));
        const basePath = location.pathname.split("/").slice(0, -1).join("/");
        navigate(basePath, { replace: true });
      }
    } catch (error) {
      const message = Array.isArray(error?.message)
        ? error?.message[0]?.Msg
        : error?.message || "Something went wrong. Please try again.";
      setSearchData((prev) => ({
        ...prev,
        searchError: message,
      }));
      // notify("danger", "Something went wrong. Please try again.");

      setSearchData((prev) => ({
        ...prev,
        searchResults: [],
        selectedUser: {},
      }));
      setAlternatives((prev) => ({
        ...prev,
        showUserDetail: false,
        isSearching: false,
        isLoading: false,
      }));
      const basePath = location.pathname.split("/").slice(0, -1).join("/");
      navigate(basePath, { replace: true });
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();

    const jointerID = searchForm?.jointerID?.trim() || "";
    const certificateNo = searchForm?.certificateNo?.trim();
    const name = searchForm?.name?.trim() || "";

    let searchError = "";
    let fieldErrors = {
      jointerID: "",
      certificateNo: "",
      name: "",
    };

    const nameError = validateField({ name: "name", value: name });
    if (nameError) fieldErrors.name = nameError;

    if (searchMode === "CERT_ID") {
      const certError = validateField({
        name: "certificateNo",
        value: certificateNo,
      });
      if (certError) fieldErrors.certificateNo = certError;
    }

    if (searchMode === "JOINTER_ID") {
      const jointerError = validateField({
        name: "jointerID",
        value: jointerID,
      });
      if (jointerError) fieldErrors.jointerID = jointerError;
    }

    // if (!jointerID && !certificateNo) {
    //   fieldErrors.jointerID = "Please enter Jointer ID or Certificate Number";
    //   fieldErrors.certificateNo = "Enter Jointer ID or Certificate Number";
    // }

    // if (jointerID && certificateNo) {
    //   fieldErrors.jointerID =
    //     "Please enter either Jointer ID or Certificate Number, not both.";
    //   fieldErrors.certificateNo =
    //     "Please enter either Jointer ID or Certificate Number, not both.";
    // }

    // const jointerIDError = validateField({
    //   name: "jointerID",
    //   value: jointerID,
    // });

    // Stop search if error exists
    // if (jointerIDError || nameError) {
    //   setSearchData((prev) => ({
    //     ...prev,
    //     searchFieldErrors: {
    //       jointerID: jointerIDError,
    //       name: nameError,
    //     },
    //   }));
    //   return;
    // }

    if (Object.values(fieldErrors).some(Boolean)) {
      setSearchData((prev) => ({
        ...prev,
        searchFieldErrors: fieldErrors,
      }));
      return;
    }

    // Clear error
    setSearchData((prev) => ({
      ...prev,
      searchError: "",
      searchFieldErrors: { jointerID: "", name: "", certificateNo: "" },
    }));

    // // Trigger API search
    let params = {};
    if (searchMode === "JOINTER_ID") {
      params = { jointerID, name, uniqueID, searchType: "JOINTER_ID" };
    }
    if (searchMode === "CERT_ID") {
      params = { certificateNo, name, uniqueID, searchType: "CERTIFICATE_NO" };
    }
    triggerSearch(params);
  };

  const handleUserClick = (user) => {
    setSearchData((prev) => ({ ...prev, selectedUser: user, setProps: true }));
    setAlternatives((prev) => ({ ...prev, showUserDetail: true }));
    triggerSearch({
      jointerUUID: user?.jointerEncodedID,
      uniqueID,
      searchType: "ENCODED_UUID",
      certificateNo: searchForm?.certificateNo,
    });
    // navigate(`/skills-verification/${user?.jointerEncodedID}`, {
    //   replace: true,
    // });
  };

  const handleClearSearch = () => {
    setSearchForm({ jointerID: "", name: "", certificateNo: "" });
    setSearchData((prev) => ({ ...prev, searchResults: [], searchError: "" }));
    setAlternatives((prev) => ({ ...prev, hasSearched: false }));
  };

  const goBackToResults = () => {
    setAlternatives((prev) => ({
      ...prev,
      showUserDetail: false,
      isSearching: false,
      hasSearched: false,
    }));
    if (!searchData.setProps) {
      setSearchForm({ jointerID: "", name: "", certificateNo: "" });
      setSearchData((prev) => ({
        ...prev,
        searchError: "",
        searchFieldErrors: {
          jointerID: false,
          name: false,
          certificateNo: false,
        },
        searchResults: [],
        selectedUser: {},
      }));
    } else {
      setSearchData((prev) => ({
        ...prev,
        setBack: true,
      }));
    }
    navigate("/skills-verification", { replace: true });
  };

  const handleNavigateHome = () => {
    setSearchForm({ jointerID: "", name: "" });
    setSearchData({
      searchError: "",
      searchFieldErrors: { jointerID: false, name: false },
      searchResults: [],
      selectedUser: {},
    });
    setAlternatives({
      showUserDetail: false,
      isSearching: false,
      hasSearched: false,
    });
    setInvalidParam(false);
    navigate("/skills-verification", { replace: true });
  };

  return (
    <>
      <VisitorVerifyModal
        isOpen={showEntryModal}
        onClose={handleCloseVisitorModal}
        setUniqueID={setUniqueID}
      />
      <div className="sv-main-container print-page">
        <MainLayout>
          <div className="sv-container print-content">
            {invalidParam ? (
              <NotFoundPage handleGoHome={handleNavigateHome} />
            ) : !alternatives.showUserDetail ? (
              <div className="sv-search-container mt-2">
                <div className="sv-section">
                  <h1 className="sv-title">Welcome to the Raychem RPG</h1>
                  <h2 className="sv-subtitle">Jointer Verification Portal.</h2>

                  <p className="sv-desc">
                    Search and verify jointer’s information.
                    {/* Verify the skills, courses, and certifications of Rasv-search-mode-titleychem-certified Jointers.
                   Search using the Jointer ID and Jointer First/Last Name to view their complete information. */}
                  </p>
                </div>
                <div className="sv-form-container">
                  <form className="sv-form">
                    <div className="sv-search-mode-card">
                      <p className="sv-search-mode-title text-muted">
                        Search by:
                      </p>

                      <div className="sv-search-mode-options">
                        <label
                          className={`sv-mode-option ${searchMode === "CERT_ID" ? "active" : ""
                            }`}
                        >
                          <input
                            type="radio"
                            name="searchMode"
                            checked={searchMode === "CERT_ID"}
                            onChange={() => handleTabChange("CERT_ID")}
                          />
                          Certificate Number
                        </label>

                        <label
                          className={`sv-mode-option ${searchMode === "JOINTER_ID" ? "active" : ""
                            }`}
                        >
                          <input
                            type="radio"
                            name="searchMode"
                            checked={searchMode === "JOINTER_ID"}
                            onChange={() => handleTabChange("JOINTER_ID")}
                          />
                          Jointer ID
                        </label>

                      </div>
                    </div>
                    {/* 
                    {searchMode === "CERT_ID" && (
                      <div className="sv-hint">
                        <i className="fas fa-info-circle fa-sm mr-1" />
                        Note: Please enter a Jointer ID or a Certificate Number
                        to proceed with the search.
                      </div>
                    )}

                    {searchMode === "JOINTER_ID" && (
                      <div className="sv-hint">
                        <i className="fas fa-info-circle fa-sm mr-1" />
                        Note: When searching by Jointer Name, please enter a
                        Jointer ID or a Certificate Number.
                      </div>
                    )} */}

                    <div className="sv-searchs-grid">
                      {/* <div className="sv-empty"></div> */}

                      {searchMode === "JOINTER_ID" && (
                        <>
                          <div className="sv-field">
                            <Label className="sv-label">
                              Jointer ID
                              <i
                                className="fas fa-info-circle text-muted fa-sm ml-2 pointer"
                                id="jointerIDPopover"
                                onMouseEnter={() => setCertificatePopover(true)}
                                onMouseLeave={() =>
                                  setCertificatePopover(false)
                                }
                              />
                            </Label>
                            <Input
                              type="text"
                              name="jointerID"
                              value={searchForm.jointerID}
                              onChange={handleInputChange}
                              placeholder="Enter jointer ID"
                              className={`sv-input ${searchData.searchFieldErrors.jointerID
                                ? "sv-input-error"
                                : ""
                                }`}
                              onKeyDown={(e) => handleKeyDown(e, true)}
                              onBlur={handleBlur}
                              autoComplete="off"
                            />
                            {searchData.searchFieldErrors.jointerID && (
                              <div className="invalid-feedback d-block ml-2 mt-2">
                                {searchData.searchFieldErrors.jointerID}
                              </div>
                            )}
                          </div>

                          <Popover
                            placement="right"
                            isOpen={certificatePopover}
                            target="jointerIDPopover"
                            toggle={() =>
                              setCertificatePopover(!certificatePopover)
                            }
                            trigger="hover"
                            className="shadow-lg border-0"
                            popperClassName="svp-jointer-popover"
                            container="body"
                            modifiers={{
                              preventOverflow: {
                                enabled: true,
                                boundariesElement: "viewport",
                                padding: 8,
                              },
                              flip: {
                                enabled: true,
                                behavior: ["right"],
                              },
                            }}
                          >
                            <PopoverBody className="svp-cert-popover-body">
                              <div className="svp-cert-popover-header">
                                <h6 className="svp-cert-title">
                                  Don’t have the Jointer ID?
                                </h6>
                              </div>
                              <hr className="svp-popover-divider" />
                              <div className="svp-cert-desc">
                                <span>
                                  Please contact the System Admin or the
                                  concerned authorized person to obtain it.
                                </span>
                              </div>
                            </PopoverBody>
                          </Popover>
                        </>
                      )}

                      {/* <div className="sv-or">OR</div>*/}

                      {searchMode === "CERT_ID" && (
                        <div className="sv-field">
                          <Label className="sv-label">Certificate Number</Label>
                          <Input
                            type="text"
                            name="certificateNo"
                            value={searchForm.certificateNo}
                            onChange={handleInputChange}
                            placeholder="Enter certificate number"
                            className={`sv-input ${searchData.searchFieldErrors.certificateNo
                              ? "sv-input-error"
                              : ""
                              }`}
                            onKeyDown={(e) => handleKeyDown(e, true)}
                            onBlur={handleBlur}
                            autoComplete="off"
                          />
                          {searchData.searchFieldErrors.certificateNo && (
                            <div className="invalid-feedback d-block ml-2 mt-2">
                              {searchData.searchFieldErrors.certificateNo}
                            </div>
                          )}
                        </div>
                      )}

                      <div className="sv-field">
                        <Label className="sv-label">Jointer Name</Label>
                        <Input
                          type="text"
                          name="name"
                          value={searchForm.name}
                          onChange={handleInputChange}
                          placeholder="Enter jointer name"
                          maxLength={20}
                          className={`sv-input ${searchData.searchFieldErrors.name
                            ? "sv-input-error"
                            : ""
                            }`}
                          onKeyDown={(e) => handleKeyDown(e)}
                          onBlur={handleBlur}
                          autoComplete="off"
                        />
                        {searchData.searchFieldErrors.name && (
                          <div className="invalid-feedback d-block ml-2 mt-2">
                            {searchData.searchFieldErrors.name}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* <div className="sv-search-grid">
                      <div className="sv-field">
                        <Label className="sv-label">
                          <i className="fas fa-hashtag sv-input-icon" />
                          Jointer ID
                        </Label>
                        <div className="sv-input-wrapper">
                          <Input
                            type="text"
                            name="jointerID"
                            value={searchForm.jointerID}
                            onChange={handleInputChange}
                            placeholder="Enter jointer ID"
                            className={`sv-input ${
                              searchData.searchFieldErrors.jointerID
                                ? "sv-input-error"
                                : ""
                            }`}
                            onKeyDown={(e) => handleKeyDown(e, true)}
                            onBlur={handleBlur}
                          />
                        </div>
                        {searchData.searchFieldErrors.jointerID && (
                          <div className="invalid-feedback d-block ml-2 mt-2">
                            {searchData.searchFieldErrors.jointerID}
                          </div>
                        )}
                      </div>

                      <div className="sv-field">
                        <Label className="sv-label">
                          <i className="fas fa-user sv-input-icon" />
                          Jointer Name
                        </Label>
                        <div className="sv-input-wrapper">
                          <Input
                            type="text"
                            name="name"
                            value={searchForm.name}
                            onChange={handleInputChange}
                            placeholder="Enter jointer name"
                            className={`sv-input ${
                              searchData.searchFieldErrors.name
                                ? "sv-input-error"
                                : ""
                            }`}
                            onKeyDown={handleKeyDown}
                            onBlur={handleBlur}
                            maxLength={20}
                          />
                        </div>
                        {searchData.searchFieldErrors.name && (
                          <div className="invalid-feedback d-block ml-2 mt-2">
                            {searchData.searchFieldErrors.name}
                          </div>
                        )}
                      </div>
                    </div> */}

                    <div className="sv-search-action mt-lg-4">
                      <Button
                        className="sv-search-btn btn-vivid-red"
                        disabled={alternatives.isSearching}
                        onClick={handleSearch}
                      >
                        {alternatives.isSearching ? (
                          <span className="sv-search-loader">
                            <i className="fas fa-spinner fa-spin fa-lg" />
                          </span>
                        ) : (
                          <>
                            <i className="fas fa-search mr-2" />
                            Find Jointer
                          </>
                        )}
                      </Button>
                    </div>

                    {searchData.searchError && (
                      <div className="sv-error-message mt-4">
                        <i className="fas fa-exclamation-circle"></i>
                        {searchData.searchError}
                      </div>
                    )}
                  </form>

                  {alternatives.hasSearched &&
                    searchData.searchResults.length > 1 && (
                      <div className="sv-results-section">
                        <div className="sv-results-header">
                          <h3 className="sv-results-title">
                            Search Results
                            {searchData.searchResults.length > 0 && (
                              <span> ({searchData.searchResults.length})</span>
                            )}
                          </h3>

                          {alternatives.hasSearched && (
                            <Button
                              className="sv-clear-btn btn-secondary"
                              onClick={handleClearSearch}
                              type="button"
                            >
                              <i className="fas fa-times"></i>
                              Clear Results
                            </Button>
                          )}
                        </div>

                        {alternatives.isSearching ? (
                          <div className="sv-results-placeholder">
                            <p>Searching for jointers...</p>
                          </div>
                        ) : alternatives.hasSearched &&
                          searchData.searchResults.length > 1 ? (
                          <div className="sv-results-list">
                            {searchData.searchResults.map((user) => {
                              const jointerName =
                                [user?.firstName, user?.lastName]
                                  .filter(Boolean)
                                  .join(" ") || "N/A";
                              return (
                                <div
                                  key={user.id}
                                  className="sv-user-card"
                                  onClick={() => handleUserClick(user)}
                                >
                                  <div className="sv-user-card-header">
                                    <div className="sv-user-avatar">
                                      <i className="fas fa-user-hard-hat"></i>
                                    </div>
                                    <div className="sv-user-info">
                                      <h3 className="sv-user-name mb-0">
                                        {jointerName}
                                      </h3>
                                      <p className="sv-user-id mb-0">
                                        Jointer ID: {user.jointerID}
                                      </p>
                                    </div>
                                    <div className="sv-user-action">
                                      <i className="fas fa-chevron-right"></i>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <div className="sv-results-placeholder">
                            <p>Please enter query above.</p>
                          </div>
                        )}
                      </div>
                    )}
                </div>
              </div>
            ) : (
              <UserDetailView
                user={searchData.selectedUser}
                onBack={goBackToResults}
                isLoading={alternatives.isLoading}
                isPDF={searchData.isPDF}
              />
            )}
          </div>
        </MainLayout>
      </div>
    </>
  );
};

export default SkillVerification;
